import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconArrowPathRight"><Path d="M15.0528 4.36309C14.2392 3.68147 13 4.25989 13 5.32124V8.00002H4.75C3.23122 8.00002 2 9.23124 2 10.75V13.25C2 14.7688 3.23122 16 4.75 16H13V18.6788C13 19.7402 14.2392 20.3186 15.0528 19.637L22.1093 13.7247C23.1827 12.8254 23.1827 11.1746 22.1093 10.2754L15.0528 4.36309Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathRight;
